export default {
    name: 'LabelItem',
    props: {
        label: {
            type: Object,
            required: true
        }
    }
};
